import React, { useState, useEffect } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import SideBar from './SideBar';
import TopNav from './TopNav';
import { API_URL } from '../config';
import Swal from 'sweetalert2';

const PettyCash = () => {
    const [pettyCashEntries, setPettyCashEntries] = useState([]);
    const [formData, setFormData] = useState({
        description: '',
        amount: '',
        pmode: 'Cash',
        currency: 'USD',
        company_id: 101,
        company_name: '',
        branch_id: 202,
        branch_name: '',
        propertyid: '',
        project: '',
        daterec: new Date().toISOString().split('T')[0],
        timerec: new Date().toLocaleTimeString(),
        datefor: new Date().toISOString().split('T')[0],
        amntrec: 100.00,
    });

    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false); // Loading state
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage] = useState(5); // Number of entries per page

    useEffect(() => {
        const fetchPettyCashEntries = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${API_URL}/pettycashpos`);
                const data = await response.json();
                setPettyCashEntries(data);
            } catch (error) {
                console.error('Error fetching petty cash entries:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPettyCashEntries();
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleAddEntry = async (e) => {
        e.preventDefault();
        setLoading(true); // Set loading to true
        try {
            const response = await fetch(`${API_URL}/pettycashpos`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Error: ${response.status} ${response.statusText} - ${errorText}`);
            }

            const newEntry = await response.json();
            setPettyCashEntries([...pettyCashEntries, newEntry]);
            handleCloseModal();
            Swal.fire('Success!', 'Petty cash entry added successfully!', 'success');
        } catch (error) {
            console.error('Error adding petty cash entry:', error);
            Swal.fire('Error!', error.message, 'error');
        } finally {
            setLoading(false); // Set loading to false
        }
    };

    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => {
        setShowModal(false);
        setFormData({
            description: '',
            amount: '',
            pmode: 'Cash',
            currency: 'USD',
            company_id: 101,
            company_name: 'Example Company',
            branch_id: 202,
            branch_name: 'Main Branch',
            propertyid: 'PROP001',
            project: 'Project A',
            daterec: new Date().toISOString().split('T')[0],
            timerec: new Date().toLocaleTimeString(),
            datefor: new Date().toISOString().split('T')[0],
            amntrec: 100.00,
        });
    };

    // Pagination Logic
    const indexOfLastEntry = currentPage * entriesPerPage;
    const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
    const currentEntries = pettyCashEntries.slice(indexOfFirstEntry, indexOfLastEntry);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div style={{ display: 'flex' }}>
            <SideBar />
            <div style={{ flex: 1, marginLeft: '250px' }}>
                <TopNav />
                <div className="container" style={{ padding: '20px' }}>
                    <h2 style={{ marginTop: '65px' }}>Petty Cash</h2>
                    <Button variant="primary" onClick={handleOpenModal}>Add Entry</Button>

                    <h3>Petty Cash Entries</h3>
                    {loading ? (
                        <div className="text-center">
                            <Spinner animation="border" />
                            <h4>Loading...</h4>
                        </div>
                    ) : (
                        <>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Date for</th>
                                        <th style={{ textAlign: 'left' }}>Description</th>
                                        <th>Amount Received</th>
                                        <th>Currency</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentEntries.map(entry => (
                                        <tr key={entry.pettycash_id}>
                                            <td>{entry.datefor}</td>
                                            <td style={{ textAlign: 'left' }}>{entry.description}</td>
                                            <td>{entry.amntrec}</td>
                                            <td>{entry.currency}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <nav>
                                <ul className="pagination">
                                    {Array.from({ length: Math.ceil(pettyCashEntries.length / entriesPerPage) }, (_, index) => (
                                        <li className={`page-item ${currentPage === index + 1 ? 'active' : ''}`} key={index}>
                                            <button className="page-link" onClick={() => paginate(index + 1)}>
                                                {index + 1}
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </>
                    )}

                    {/* Modal for Adding Petty Cash Entry */}
                    <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Add Petty Cash Entry</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={handleAddEntry}>
                                <div className="mb-3">
                                    <label htmlFor="description" className="form-label">Description</label>
                                    <input
                                        type="text"
                                        id="description"
                                        name="description"
                                        className="form-control"
                                        value={formData.description}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="amount" className="form-label">Amount</label>
                                    <input
                                        type="number"
                                        id="amount"
                                        name="amount"
                                        className="form-control"
                                        value={formData.amount}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="pmode" className="form-label">Payment Mode</label>
                                    <select
                                        id="pmode"
                                        name="pmode"
                                        className="form-select"
                                        value={formData.pmode}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="Cash">Cash</option>
                                        <option value="Credit Card">Credit Card</option>
                                        <option value="Bank Transfer">Bank Transfer</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="currency" className="form-label">Currency</label>
                                    <select
                                        id="currency"
                                        name="currency"
                                        className="form-select"
                                        value={formData.currency}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="USD">USD</option>
                                        <option value="EUR">EUR</option>
                                        <option value="GBP">GBP</option>
                                    </select>
                                </div>
                                {loading ? ( // Show loading spinner in modal
                                    <div className="text-center">
                                        <Spinner animation="border" />
                                        <h4>Adding Entry...</h4>
                                    </div>
                                ) : (
                                    <Button variant="primary" type="submit">Add Entry</Button>
                                )}
                            </form>
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default PettyCash;